import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { TrimStringPipe } from 'src/app/pipes/trim-string.pipe';

import { SnackbarItem, SnackbarService } from './snackbar.service';
/**
 * A component that manages the snackbar.
 *
 * ```ts
 *  @Output() closed: EventEmitter<SnacbarItem> -  When register to this event it will triggered snackbar closed.
 * ```
 *
 * Add the below code to your code stack and give initializer parameters.
 *
 * <sub>app.component.html</sub>
 * ```html
 *  <tbtk-snackbar (closed)="onSnackbarClose($event)"></tbtk-snackbar>
 * ```
 */
@Component({
  selector: 'tbtk-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  providers: [TrimStringPipe],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate('300ms ease-in', style({ opacity: 1 }))]),
      transition(':leave', [animate('200ms ease-out', style({ opacity: 0 }))]),
    ]),
  ],
})
export class SnackbarComponent implements OnDestroy {
  @Output() closed: EventEmitter<SnackbarItem> = new EventEmitter<SnackbarItem>();

  constructor(public snackbarService: SnackbarService, public trimStringPipe: TrimStringPipe) {
    this.snackbarService.listener$.subscribe((snackbar: SnackbarItem) => {
      this.closed.emit(snackbar);
    });
  }

  ngOnDestroy(): void {
    this.snackbarService.listener$.unsubscribe();
  }

  public onMouseEnter(snackbar: SnackbarItem): void {
    this.snackbarService.clearTimeout(snackbar);
  }

  public onMouseLeave(snackbar: SnackbarItem): void {
    this.snackbarService.starTimeout(snackbar);
  }

  public onCloseClick(snackbar: SnackbarItem): void {
    this.snackbarService.close(snackbar);
    this.closed.emit(snackbar);
  }
}
